import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChanelType, ChatStore, SendMessageToStoreType } from '../../shared';
import { fetchChatRooms, initChatRooms, sendChatMessage } from './thunk';
import { MessageResponseBase } from 'stream-chat';
import { environment } from 'src/enviroments';

const initialState: ChatStore = {
  isLoading: false,
  error: null,
  channels: [],
  isEmptyModalOpen: false,
  sendMessageTo: null,
  isStreamChatEnabled: environment.REMOTE_CONFIG.DEFAULT_VALUES.is_stream_chat_enabled,
  unreadMessageCount: 0,
};

const chatReducer = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    openEmptyChatModal: (state) => {
      state.isEmptyModalOpen = true;
    },
    closeEmptyChatModal: (state) => {
      state.isEmptyModalOpen = false;
    },
    setSendMessageTo: (state, action: PayloadAction<SendMessageToStoreType | null>) => {
      return { ...state, sendMessageTo: action.payload };
    },
    enableStreamChat: (state) => {
      state.isStreamChatEnabled = true;
    },
    disableStreamChat: (state) => {
      state.isStreamChatEnabled = false;
    },
    setUnreadMessageCount: (state, action: PayloadAction<number>) => {
      state.unreadMessageCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initChatRooms.fulfilled, (state, action: PayloadAction<ChanelType[]>) => {
        state.isLoading = false;
        state.channels = action.payload;
      })
      .addCase(fetchChatRooms.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchChatRooms.fulfilled, (state, action: PayloadAction<ChanelType[]>) => {
        state.isLoading = false;
        state.channels = action.payload;
      })
      .addCase(fetchChatRooms.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(sendChatMessage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        sendChatMessage.fulfilled,
        (state, action: PayloadAction<{ message: MessageResponseBase; to: string }>) => {
          state.isLoading = false;
          if (action.payload?.message?.cid && action.payload?.message?.user) {
            state.channels.push({
              id: action.payload.message.cid.replace('messaging:', ''),
              members: [action.payload.message.user.id, action.payload.to],
            });
          }
        }
      )
      .addCase(sendChatMessage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const {
  openEmptyChatModal,
  closeEmptyChatModal,
  setSendMessageTo,
  enableStreamChat,
  disableStreamChat,
  setUnreadMessageCount,
} = chatReducer.actions;

export default chatReducer.reducer;
